import { IonButton } from "@ionic/react";
import { ComponentProps, ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/buttons/TertiaryButton.module.css";
import TertiaryButtonIcon from "@components/typography/icons/TertiaryButtonIcon";
import TertiaryButtonText from "@components/typography/TertiaryButtonText";
import { IconName } from "@utils/iconUtils";

type ButtonProps = Pick<
  ComponentProps<typeof IonButton>,
  | "disabled"
  | "download"
  | "href"
  | "mode"
  | "onClick"
  | "onIonBlur"
  | "onIonFocus"
  | "onKeyUp"
  | "rel"
  | "role"
  | "routerLink"
  | "target"
  | "type"
>;

type IconPosition = "end" | "start";

type Props = ButtonProps & {
  className?: string;
  color?: "secondary-300" | "white" | "gray-500";
  icon?: IconName;
  iconPosition?: IconPosition;
  large?: boolean;
  text?: string | ReactNode;
  textKey?: string;
  withSpacing?: boolean;
};

const TertiaryButton = ({
  className,
  color,
  icon,
  iconPosition = "start",
  large = false,
  text,
  textKey,
  withSpacing = false,
  ...buttonProps
}: Props) => (
  <IonButton
    className={`${styles.button} ${withSpacing ? styles.withSpacing : ""} ${className ?? ""} ${styles[color ?? ""]}`}
    {...buttonProps}
  >
    {iconPosition === "end" && (text || textKey) && (
      <TertiaryButtonText large={large}>{text ? text : <FormattedMessage id={textKey} />}</TertiaryButtonText>
    )}
    {icon && (
      <span className={iconPosition === "end" ? styles.iconEnd : styles.iconStart}>
        <TertiaryButtonIcon icon={icon} large={large} />
      </span>
    )}
    {iconPosition === "start" && (text || textKey) && (
      <TertiaryButtonText large={large}>{text ? text : <FormattedMessage id={textKey} />}</TertiaryButtonText>
    )}
  </IonButton>
);

export default TertiaryButton;
